import { LitElement, html, unsafeCSS } from "lit"
import { customElement, property } from "lit/decorators.js"
import styles from "./styles/wordmark.css?inline"

@customElement("app-wordmark")
export class Wordmark extends LitElement {
  @property({ type: Boolean }) showTrademark = false

  static styles = unsafeCSS(styles)

  protected render() {
    return html`
      <span class="wordmark-text">Conjunction</span
      ><span class="wordmark-number">1</span>${this.showTrademark
        ? html`<span class="trademark">™</span>`
        : null}
    `
  }
}
